var map = {
	"./aerosoldose.jpg": 3629,
	"./ampulle.jpg": 457,
	"./arzneiblister.jpg": 6808,
	"./banderole.jpg": 7214,
	"./becherdose.jpg": 5524,
	"./beutel.jpg": 3418,
	"./eimer.jpg": 6809,
	"./einschlagpapier.jpg": 5007,
	"./faltschachtel.jpg": 7181,
	"./fluessigkarton.jpg": 4198,
	"./folie.jpg": 2981,
	"./formteil.jpg": 4046,
	"./funktionsflasche.jpg": 7427,
	"./getrankeflasche.jpg": 183,
	"./gewuerzmuehle.jpg": 319,
	"./glasflasche.jpg": 85,
	"./haengeblister.jpg": 9266,
	"./hangtag.jpg": 6383,
	"./kanister.jpg": 8519,
	"./kantenschutz.jpg": 4861,
	"./karton.jpg": 1307,
	"./kartusche.jpg": 292,
	"./konservendose.jpg": 2733,
	"./korb.jpg": 4042,
	"./netz.jpg": 7552,
	"./obstschale.jpg": 7773,
	"./roehre.jpg": 6643,
	"./rolle.jpg": 2697,
	"./rolletextilband.jpg": 3407,
	"./sack.jpg": 6127,
	"./schachtelgeschlossen.jpg": 962,
	"./schachteloffen.jpg": 7526,
	"./schlauchfolienbeutel.jpg": 2429,
	"./schraubdeckeldose.jpg": 4184,
	"./sichtfensterbeutel.jpg": 3074,
	"./sonstige.jpg": 5864,
	"./standbodenbeutel.jpg": 709,
	"./steige.jpg": 6617,
	"./stift.jpg": 1435,
	"./traegerplatte.jpg": 970,
	"./tray.jpg": 2782,
	"./tubeapplikator.jpg": 9958,
	"./tubepaste.jpg": 8601,
	"./tuete.jpg": 640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1826;